import React, { useEffect, useRef, useState } from "react";
import { FC } from "react";
import { Border } from "victory";
import '../externaldoc.scss'
import { LeadBasePaint1 } from "../SharedocHTML";
import Esign from "../Esign";
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useDispatch, useSelector } from "react-redux";
import { notification_success } from "../../../../state/actions";
import { getexternaldocuments, getSavedOfferDetails, saveEsign, sendleadbasepaint } from "../../../../api/transaction";
import store, { stor1 } from "../../../../store";
import moment from 'moment'
import { useParams } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";

export const LeadBasePaint: FC = () => {

    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [offerdetails, setOfferDetails] = useState({});
    const [reviewdocs, setReviewdocs] = useState(false);
    const { id, user }: any = useParams()
    const componentRef = useRef();
    const [loader, setloading] = useState(false)
    const [leadbasepaint, setLeadBasePaint] = useState({
        offer_id: Number(id),
        address: "",
        seller_disclosure_chk1: false,
        seller_disclosure_chk2: false,
        seller_disclosure_chk3: false,
        seller_disclosure_chk4: false,
        seller_disclosure_comments1:"",
        seller_disclosure_comments2:"",
        purchaseer_ack_value1: "",
        purchaseer_ack_value2: "",
        purchaser_ack_chk1: false,
        purchaser_ack_chk2: false,
        agent_ackhnowledge: "",
        seller1: "",
        seller2: "",
        seller3: "",
        purchaser1: "",
        purchaser2: "",
        purchaser3: "",
        seller1_date: null,
        seller2_date: null,
        seller3_date: null,
        purchaser1_date: null,
        purchaser2_date: null,
        purchaser3_date: null,
    })
    const [spinner, setspinner] = useState(false)
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid: "",
        document_name: "",
        image_base64: "",
        sign_role: 1
    })
    const leadpaintref = useRef(null)

    useEffect(() => {
        (async function () {
            let offerdetails = await getSavedOfferDetails(id)
            setOfferDetails(offerdetails[0])
            setLeadBasePaint({ ...leadbasepaint, address: offerdetails[0]?.propertyAddress })
            const res = await getexternaldocuments(id, "leadbasedpaint")
            setLeadBasePaint({
                ...leadbasepaint,
                address: res?.data?.address,
                seller_disclosure_chk1: res?.data?.seller_disclosure_chk1,
                seller_disclosure_chk2: res?.data?.seller_disclosure_chk2,
                seller_disclosure_chk3: res?.data?.seller_disclosure_chk3,
                seller_disclosure_chk4: res?.data?.seller_disclosure_chk4,
                purchaseer_ack_value1: res?.data?.purchaseer_ack_value1,
                purchaseer_ack_value2: res?.data?.purchaseer_ack_value2,
                purchaser_ack_chk1: res?.data?.purchaser_ack_chk1,
                purchaser_ack_chk2: res?.data?.purchaser_ack_chk2,
                agent_ackhnowledge: res?.data?.agent_ackhnowledge,
                seller1: res?.data?.seller1,
                seller2: res?.data?.seller2,
                seller3: res?.data?.seller3,
                purchaser1: res?.data?.purchaser1,
                purchaser2: res?.data?.purchaser2,
                purchaser3: res?.data?.purchaser3,
                seller1_date: res?.data?.seller1_date,
                seller2_date: res?.data?.seller2_date,
                seller3_date: res?.data?.seller3_date,
                purchaser1_date: res?.data?.purchaser1_date,
                purchaser2_date: res?.data?.purchaser2_date,
                purchaser3_date: res?.data?.purchaser3_date,
            })
        })()

    }, [])

    const printf = async () => {
        handlePrint()
    }

    const dispatch = useDispatch()
    const handleSaveDocumentEsign = async () => {
        setspinner(true)

        let savedsignres: any = await saveEsign(selecteddocumentesign);

        if (savedsignres?.statuscode === 200) {
            dispatch(
                notification_success({
                    id: "4",
                    message: `E-sign saved succesfully.`,
                })
            );
        }
        setspinner(false)
    }
    const [sign, setsign] = useState("")
    // @ts-ignore
    const val = useSelector((state) => state?.new?.signset)
    // const seller_date = () => { const d = new Date(); setLeadBasePaint({ ...leadbasepaint, seller1_date: new Date() }) }

    useEffect(()=>{
        if(val){
          if(user == "seller"){
            setLeadBasePaint({ ...leadbasepaint, seller1: val }) 
          }
          if(user == "client"){
            setLeadBasePaint({ ...leadbasepaint, purchaser1: val }) 
          }
        }
        },[val])

    const send = async () => {
        setloading(true)

        // await seller_date()
        if (user === "seller") {
       
            if(leadbasepaint?.seller1){
            let res = await sendleadbasepaint(leadbasepaint)
            if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }
            }
        }
        else if(user == "client" ) {
     
            if(leadbasepaint?.purchaser1){
              let res =   await sendleadbasepaint(leadbasepaint)
              if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }

            }
        }
        
        setloading(false)
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <>
            <section ref={componentRef} className="leadbasepaint">
                <table className="leadbasepaint_table">
                    <tr>
                        <td>
                            <table className="w-100">
                                <tr>
                                    <td className="w-90"><img className="w-250px"
                                        src="https://storagemilforddev.blob.core.windows.net/images/logo.svg" /></td>

                                    <td>
                                        <img style={{ width: "30px" }}
                                            src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg" alt="" />
                                        <img style={{ width: '50px' }}
                                            src="https://storagemilforddev.blob.core.windows.net/images/eh.svg" alt="" />
                                    </td>

                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr >
                        <td className="p-10-0">
                            <span style={{ fontWeight: 700, fontSize: "25px" }} >Disclosure of Information on Lead-Based Paint &/or Lead-Based Paint Hazards</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="p-10-0">

                            <span >  <span style={{ fontWeight: 600, color: "#3b0083" }}>ADDRESS:</span>
                            {/* @ts-ignore */}
                                <input type="text" id="address" value={offerdetails?.propertyAddress}
                                    //  onChange={(e)=>{setLeadBasePaint({...leadbasepaint,address:e.target.value})}} 
                                    // style="  outline: none; border: none; border-bottom:1px solid black; width:950px;" 
                                    style={{ border: "none", borderBottom: "1px solid black", width: "950px" }}
                                />
                            </span>
                        </td>
                    </tr>
                    <tr >
                        <td className="p-10-0">
                            <span style={{ fontWeight: 600, color: "#3b0083", fontSize: "20px" }} >LEAD WARNING STATEMENT</span><br />
                            <span>Every purchaser of any interest in residential real property on which a residential dwelling was built prior to 1978 is notified that such property may present exposure to lead from lead-based
                                paint that may place young children at risk of developing lead poisoning. Lead poisoning in young children may produce permanent neurological damage, including learning disabilities, reduced
                                intelligence quotient, behavioral problems, and impaired memory. Lead poisoning also poses a particular risk to pregnant women. The seller of any interest in residential real property is required to
                                provide the buyer with any information on lead-based paint hazards from risk assessments or inspections in the seller’s possession and notify the buyer of any known lead-based paint hazards. A risk
                                assessment or inspection for possible lead-based paint hazards is recommended prior to purchase.</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ fontWeight: 600, color: "#3b0083", fontSize: "20px" }}>Seller’s Disclosure</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span>( a ) Presence of lead-based paint and/or lead-based paint hazards (check (i) or (ii) below):</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>( i )
                                <input type="checkbox" id="seller_disclosure_chk1" checked={leadbasepaint?.seller_disclosure_chk1} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, seller_disclosure_chk1: !leadbasepaint?.seller_disclosure_chk1 }) }} />
                                Known lead-based paint and/or lead-based paint hazards are present in the housing (explain).


                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>   <input type="text"
                            value={leadbasepaint?.seller_disclosure_comments1} onChange={(e)=>setLeadBasePaint({...leadbasepaint,seller_disclosure_comments1:e.target.value})}
                                style={{ width: "1000px", borderBottom: "1px solid black" }} /></span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>( ii ) <input type="checkbox" id="seller_disclosure_chk2" checked={leadbasepaint?.seller_disclosure_chk2} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, seller_disclosure_chk2: !(leadbasepaint?.seller_disclosure_chk2) }) }} />
                                Seller has no knowledge of lead-based paint and/or lead-based paint hazards in the housing.


                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span>( b )  Records and reports available to the seller (check (i) or (ii) below):</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>( i ) <input type="checkbox" id="seller_disclosure_chk3" checked={leadbasepaint?.seller_disclosure_chk3} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, seller_disclosure_chk3: !leadbasepaint?.seller_disclosure_chk3 }) }} />Seller has provided the purchaser with all available records and reports pertaining to lead-based paint and/or
                                lead-based paint hazards in the housing (list documents below).


                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>   <input type="text"
                            value={leadbasepaint?.seller_disclosure_comments2} onChange={(e)=>setLeadBasePaint({...leadbasepaint,seller_disclosure_comments2:e.target.value})}
                                style={{ width: "1000px", borderBottom: "1px solid black" }} /></span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>( ii ) <input type="checkbox" id="seller_disclosure_chk4" checked={leadbasepaint?.seller_disclosure_chk4} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, seller_disclosure_chk4: !leadbasepaint?.seller_disclosure_chk4 }) }} />Seller has no reports or records pertaining to lead-based paint and/or lead-based paint hazards in the housing.


                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ fontWeight: 600, color: "#3b0083" }}>Purchaser’s Acknowledgment</span>
                            <span>(initial)</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span>( c ) <input type="text" id="purchaseer_ack_value1" value={leadbasepaint?.purchaseer_ack_value1} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, purchaseer_ack_value1: e.target.value }) }}
                                style={{ width: "100px" }} />Purchaser has received copies of all information listed above.</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span>(  d ) <input type="text" id="purchaseer_ack_value2" value={leadbasepaint?.purchaseer_ack_value2} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, purchaseer_ack_value2: e.target.value }) }}
                                style={{ width: "100px" }} />Purchaser has received the pamphlet Protect Your Family from Lead in Your Home.</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span>( e ) Purchaser has (check (i) or (ii) below):</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>( i ) <input type="checkbox" id="purchaser_ack_chk1" checked={leadbasepaint?.purchaser_ack_chk1} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, purchaser_ack_chk1: !(leadbasepaint?.purchaser_ack_chk1) }) }} />
                                Known lead-based paint and/or lead-based paint hazards are present in the housing (explain).


                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ paddingLeft: "80px" }}>( ii ) <input type="checkbox" id="purchaser_ack_chk2" checked={leadbasepaint?.purchaser_ack_chk2} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, purchaser_ack_chk2: !(leadbasepaint?.purchaser_ack_chk2) }) }} />
                                Seller has no knowledge of lead-based paint and/or lead-based paint hazards in the housing.


                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ fontWeight: 600, color: "#3b0083" }}>Agent Acknowledgment</span>
                            <span>(initial)</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span>( f ) <input type="text" id="agent_ackhnowledge" value={leadbasepaint?.agent_ackhnowledge} onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, agent_ackhnowledge: e.target.value }) }}
                                style={{ width: "100px" }} />Agent has informed the seller of the seller’s obligations under 42 U.S.C. 4852(d) and is aware of his/her responsibility to ensure compliance.</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <span style={{ fontWeight: 600, color: "#3b0083" }}>Certification of Accuracy</span><br />
                            <span>The following parties have reviewed the information above and certify, to the best of their knowledge, that the information they have provided is true and accurate. </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <table style={{ width: "100%", tableLayout: "fixed" }}>
                                <tr>
                                    <td>
                                        <span>
                                            {/* <input type="text" id="seller1"
                                style={{width:'500px'}}/> */}
                                        </span>
                                        <img src={user === "seller" ? (val || leadbasepaint?.seller1) : leadbasepaint?.seller1} alt="" style={{width: '100%', maxWidth: '230px'}} />
                                        <br />
                                        <span > Seller</span>
                                    </td>
                                    <td>
                                        <span>
                                            <input type="date" id="seller1_date"
                                             value={leadbasepaint?.seller1_date ? leadbasepaint?.seller1_date  : (user === "seller" && val || leadbasepaint?.seller1) ? new Date().toISOString().split('T')[0] : ""} 
                                             onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, seller1_date: e.target.value }) }}
                                            />
                                        </span><br />
                                        <span> Date</span>
                                    </td>
                                    <td>
                                        <img src={user === "client" ? (val || leadbasepaint?.purchaser1) : leadbasepaint?.purchaser1} alt="" style={{width: '100%', maxWidth: '230px'}}/><br />
                                        <span > Purchase</span>
                                    </td>
                                    <td>
                                        <span>
                                            <input type="date" id="seller1_date"
                                             value={leadbasepaint?.purchaser1_date ? leadbasepaint?.purchaser1_date   : (user === "client" && val || leadbasepaint?.purchaser1) ? new Date().toISOString().split('T')[0] : ""} 
                                             onChange={(e) => { setLeadBasePaint({ ...leadbasepaint, purchaser1_date: e.target.value }) }}/>
                                        </span><br />
                                        <span> Date</span>
                                    </td>
                                </tr>


                            </table>
                        </td>
                    </tr>
                
                    <tr>
                        <td style={{padding: '15px 0px'}}>
                            <table style={{width: '100%'}}>
                                <tr>
                                    <td>
                                        <input type="text"
                                            style={{outline: 'none', border: 'none', borderBottom:'1px solid black', width: '250px'}}/><br />
                                        Seller
                                    </td>
                                    <td>
                                        <input type="date"/><br />
                                        Date
                                    </td>
                                    <td>
                                        <input type="text"
                                            style={{outline: 'none', border: 'none', borderBottom:'1px solid black', width: '250px'}}/><br />
                                        Purchase
                                    </td>
                                    <td>
                                        <input type="date"/><br />
                                        Date
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                
                    <tr>
                        <td style={{padding: '15px 0px'}}>
                            <table style={{width: '100%'}}>
                                <tr>
                                    <td>
                                        <input type="text"
                                            style={{outline: 'none', border: 'none', borderBottom:'1px solid black', width: '250px'}}/><br />
                                        Seller
                                    </td>
                                    <td>
                                        <input type="date"/><br />
                                        Date
                                    </td>
                                    <td>
                                        <input type="text"
                                            style={{outline: 'none', border: 'none', borderBottom:'1px solid black', width: '250px'}}/><br />
                                        Purchase
                                    </td>
                                    <td>
                                        <input type="date"/><br />
                                        Date
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ paddingTop: "10px" }}>
                            <span>Other provisions: Earnest deposit to be delivered within (5) business days</span>
                        </td>
                    </tr>
                </table>
            </section>
            {
                user !== "agent" &&
                <><React.Fragment>
                    <div className="d-flex align-items-center justify-content-end mb-2 mr-2">
                        <button onClick={send} className="btn primaryColorBtn">Submit
                            {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
                        </button>
                        <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
                        <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>
                    </div>
                </React.Fragment>
                    <Esign
                        canvasmodal={canvasmodal}
                        setCanvasModal={setCanvasModal}
                        htmlContent={htmlContent}
                        setHtmlContent={setHtmlContent}
                        selecteddocumentesign={selecteddocumentesign}
                        setselectedDocumentEsign={setselectedDocumentEsign}
                        type={"seller"}
                    ></Esign>

                </>
            }

        </>
    )
};
